export var DebitCardValidationProviderType;
(function (DebitCardValidationProviderType) {
    DebitCardValidationProviderType["SHUMAIDATA"] = "shumaidata";
    DebitCardValidationProviderType["FEGINE"] = "fegine";
    DebitCardValidationProviderType["DEEPFINCH"] = "deepfinch";
    DebitCardValidationProviderType["HUAJI"] = "huaji"; // 华际云数
})(DebitCardValidationProviderType || (DebitCardValidationProviderType = {}));
//# sourceMappingURL=DebitCardValidationProviderType.js.map